/**
 * Unique permission IDs for each feature.
 */
export const PERMISSION_IDS = {
  SCHEDULE_ENERGY: "schedule_energy",
  SCHEDULE_POWER: "schedule_power",
  SCHEDULING_HUB: "scheduling_hub",
  BM_INSTRUCTIONS: "bm_instructions",
  BM_AUTOMATION: "bm_automation",
  AVAILABILITY_PLANNING: "availability_planning",
} as const;

export type PermissionId = (typeof PERMISSION_IDS)[keyof typeof PERMISSION_IDS];
